module.exports = __webpack_public_path__ + "img/drt20.2f17eecf.png";